import { useEffect, useState } from "react"

import { useLazyGetOrderProductsQuery } from "store/api/widgetsApi"
import { FeatureFlag, isFeatureEnabled } from "store/featureFlagsSlice"
import { useAppSelector } from "store/hooks"

import { getDateRangeFromOption } from "utils/dateUtils"
import { HalfDoughnutLegendGroups, HalfDoughnutSummaryWidget } from "components/widgets/HalfDoughnutSummaryWidget"
import { allDateSelectOptions } from "pages/vendor/Dashboard/constants"

import { buildDeviceOrderGroups } from "./items"

const initialState = {
  total: 0,
  cwa: 0,
  thermostatV1: 0,
  thermostatV2: 0,
  ths: 0,
  wls: 0,
}

export const WidgetDevicesOrderedByType = () => {
  const [selectedDateRange, setSelectedDateRange] = useState(() =>
    getDateRangeFromOption(String(allDateSelectOptions[0].value)),
  )
  const [triggerGetOrderProducts, { isFetching }] = useLazyGetOrderProductsQuery()
  const [widgetData, setWidgetData] = useState(initialState)
  const thermv2ordering = useAppSelector(isFeatureEnabled(FeatureFlag.ThermV2Ordering))
  const showSensors = useAppSelector(isFeatureEnabled(FeatureFlag.SensorsOrdering))

  useEffect(() => {
    const fetchData = async () => {
      const res = await triggerGetOrderProducts({
        date_start: selectedDateRange[0],
        date_end: selectedDateRange[1],
      })
      if (res?.data?.data) {
        const d = res.data.data
        setWidgetData({
          total: d.total ?? 0,
          cwa: d.cwa ?? 0,
          thermostatV1: d.thermostat_v1 ?? 0,
          thermostatV2: d.thermostat_v2 ?? 0,
          ths: d.ths ?? 0,
          wls: d.wls ?? 0,
        })
      }
    }

    fetchData()
  }, [selectedDateRange, triggerGetOrderProducts])

  const groups = buildDeviceOrderGroups({ thermv2ordering, showSensors }, widgetData)
  const items = groups.flat()

  const total = items.reduce((sum, item) => sum + item.value, 0)

  return (
    <HalfDoughnutSummaryWidget
      title="Devices Ordered by Type"
      mainLabel="Devices ordered"
      chartOptions={{ cutout: "65%" }}
      isFetching={isFetching}
      dateSelectOptions={allDateSelectOptions}
      minDate="2025-05-27"
      onSelectDateRange={setSelectedDateRange}
      defaultSelectedDateOption={allDateSelectOptions[0]}
      showPercentage
      items={items}
      legendContent={showSensors ? <HalfDoughnutLegendGroups groups={groups} total={total} /> : undefined}
    />
  )
}
